// extracted by mini-css-extract-plugin
export default {"tile":"Tile_tile__YNahe","checked":"Tile_checked__IxsM+","image":"Tile_image__ePGsI","labeltext":"Tile_labeltext__3oHuK","button":"Tile_button__H9Ero"};